module.exports = __webpack_public_path__ + "img/x.b5c41cdc.svg";